/**
 * Utilitário para construção de breadcrumbs baseado na hierarquia do sistema
 */

/**
 * Constrói breadcrumbs para páginas de nível de organização
 * @param {Object} currentOrganization - Organização atual do usuário
 * @param {string} pageName - Nome da página atual
 * @param {string} pagePath - Caminho da página atual
 * @returns {Array} Array de objetos breadcrumb
 */
export const buildOrgLevelBreadcrumbs = (currentOrganization, pageName, pagePath) => {
  const breadcrumbs = [];
  
  // Admin sempre vem primeiro
  breadcrumbs.push({ 
    id: '/', 
    label: 'admin', 
    key: 'admin',
    path: '/'
  });
  
  // Organização atual
  if (currentOrganization?.id) {
    breadcrumbs.push({
      id: currentOrganization.id,
      label: currentOrganization.name,
      key: 'org',
      path: `/prefeitura/${currentOrganization.id}`
    });
  }
  
  // Página atual
  if (pageName && pagePath) {
    breadcrumbs.push({
      id: pagePath,
      label: pageName,
      key: 'page',
      path: pagePath
    });
  }
  
  return breadcrumbs;
};

/**
 * Constrói breadcrumbs para páginas de nível de branch
 * @param {Object} currentOrganization - Organização atual do usuário
 * @param {Object} currentBranch - Branch atual
 * @param {string} pageName - Nome da página atual
 * @param {string} pagePath - Caminho da página atual
 * @returns {Array} Array de objetos breadcrumb
 */
export const buildBranchLevelBreadcrumbs = (currentOrganization, currentBranch, pageName, pagePath) => {
  const breadcrumbs = [];
  
  // Admin sempre vem primeiro
  breadcrumbs.push({ 
    id: '/', 
    label: 'admin', 
    key: 'admin',
    path: '/'
  });
  
  // Organização atual
  if (currentOrganization?.id) {
    breadcrumbs.push({
      id: currentOrganization.id,
      label: currentOrganization.name,
      key: 'org',
      path: `/prefeitura/${currentOrganization.id}`
    });
  }
  
  // Branch atual
  if (currentBranch?.id) {
    breadcrumbs.push({
      id: currentBranch.id,
      label: currentBranch.name,
      key: 'branch',
      path: `/prefeitura/secretaria/${currentBranch.id}`
    });
  }
  
  // Página atual
  if (pageName && pagePath) {
    breadcrumbs.push({
      id: pagePath,
      label: pageName,
      key: 'page',
      path: pagePath
    });
  }
  
  return breadcrumbs;
};

/**
 * Constrói breadcrumbs para páginas de nível de unidade
 * @param {Object} currentOrganization - Organização atual do usuário
 * @param {Object} currentBranch - Branch atual
 * @param {Object} currentUnit - Unidade atual
 * @param {string} pageName - Nome da página atual
 * @param {string} pagePath - Caminho da página atual
 * @returns {Array} Array de objetos breadcrumb
 */
export const buildUnitLevelBreadcrumbs = (currentOrganization, currentBranch, currentUnit, pageName, pagePath) => {
  const breadcrumbs = [];
  
  // Admin sempre vem primeiro
  breadcrumbs.push({ 
    id: '/', 
    label: 'admin', 
    key: 'admin',
    path: '/'
  });
  
  // Organização atual
  if (currentOrganization?.id) {
    breadcrumbs.push({
      id: currentOrganization.id,
      label: currentOrganization.name,
      key: 'org',
      path: `/prefeitura/${currentOrganization.id}`
    });
  }
  
  // Branch atual
  if (currentBranch?.id) {
    breadcrumbs.push({
      id: currentBranch.id,
      label: currentBranch.name,
      key: 'branch',
      path: `/prefeitura/secretaria/${currentBranch.id}`
    });
  }
  
  // Unidade atual
  if (currentUnit?.id) {
    breadcrumbs.push({
      id: currentUnit.id,
      label: currentUnit.name,
      key: 'unit',
      path: `/prefeitura/secretaria/unidade/${currentUnit.id}`
    });
  }
  
  // Página atual
  if (pageName && pagePath) {
    breadcrumbs.push({
      id: pagePath,
      label: pageName,
      key: 'page',
      path: pagePath
    });
  }
  
  return breadcrumbs;
};

/**
 * Constrói breadcrumbs para páginas de nível de departamento
 * @param {Object} currentOrganization - Organização atual do usuário
 * @param {Object} currentBranch - Branch atual
 * @param {Object} currentUnit - Unidade atual
 * @param {Object} currentDepartment - Departamento atual
 * @param {string} pageName - Nome da página atual
 * @param {string} pagePath - Caminho da página atual
 * @returns {Array} Array de objetos breadcrumb
 */
export const buildDepartmentLevelBreadcrumbs = (currentOrganization, currentBranch, currentUnit, currentDepartment, pageName, pagePath) => {
  const breadcrumbs = [];
  
  // Admin sempre vem primeiro
  breadcrumbs.push({ 
    id: '/', 
    label: 'admin', 
    key: 'admin',
    path: '/'
  });
  
  // Organização atual
  if (currentOrganization?.id) {
    breadcrumbs.push({
      id: currentOrganization.id,
      label: currentOrganization.name,
      key: 'org',
      path: `/prefeitura/${currentOrganization.id}`
    });
  }
  
  // Branch atual
  if (currentBranch?.id) {
    breadcrumbs.push({
      id: currentBranch.id,
      label: currentBranch.name,
      key: 'branch',
      path: `/prefeitura/secretaria/${currentBranch.id}`
    });
  }
  
  // Unidade atual
  if (currentUnit?.id) {
    breadcrumbs.push({
      id: currentUnit.id,
      label: currentUnit.name,
      key: 'unit',
      path: `/prefeitura/secretaria/unidade/${currentUnit.id}`
    });
  }
  
  // Departamento atual
  if (currentDepartment?.id) {
    breadcrumbs.push({
      id: currentDepartment.id,
      label: currentDepartment.name,
      key: 'department',
      path: `/prefeitura/secretaria/unidade/departamento/${currentDepartment.id}`
    });
  }
  
  // Página atual
  if (pageName && pagePath) {
    breadcrumbs.push({
      id: pagePath,
      label: pageName,
      key: 'page',
      path: pagePath
    });
  }
  
  return breadcrumbs;
};
